module.exports = __webpack_public_path__ + "static/peppers-menu-outside-2a68e50c11cddf148e4d1dd99213dd19.jpg";